<template>
  <el-container>
    <el-header style="height: auto;">
      <el-form>
        <el-form-item label="地区">
          <el-cascader
              clearable
              style="width: 500px;"
              v-model="conditions.division"
              :options="division"
              :props="{checkStrictly: true}"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input v-model="conditions.keywords"/>
        </el-form-item>
        <div>
          <el-button type="primary" @click="jumpTo(1)">
            搜索
          </el-button>
          <el-button type="primary" @click="newDivision">
            录入
          </el-button>
        </div>
      </el-form>
    </el-header>
    <el-main>
      <el-table :data="scenicSpots">
        <el-table-column prop="id" label="景区ID"/>
        <el-table-column prop="name" label="名称"/>
        <el-table-column prop="isHot" label="热门景区">
          <template #default="{row:{isHot}}">
            <span v-if="isHot" style="color:red">
              热门
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="isHot" label="需要预约">
          <template #default="{row:{needBooking}}">
            <span v-if="needBooking" style="color:red">
              是
            </span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="division" label="地址">
          <template #default="{row:{division, location, id}}">
            {{division}}
            <router-link v-if="!location"  style="color: red; cursor: pointer;" :to="{name: 'EditScenicSpots', params: {id}}">
              导航未录入
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作">
          <template #default="{row:{id}}">
            <el-button size="small" type="primary" @click="$router.push({name: 'EditScenicSpots', params: {id}})">编辑
            </el-button>
            <el-button size="small" type="danger" @click="deleteScenic(id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="jumpTo" :page-size="pagination.pageSize" :total="pagination.total">

      </el-pagination>
    </el-main>
  </el-container>
</template>
<script>
import division from '../../../constants/divisions.json'
import {onMounted, reactive, ref} from 'vue'
import {useRouter} from 'vue-router'
import axios from '../../../request'
import usePagination from '../../../hooks/usePagination'
import useDeleteScenicSpots from '../../../hooks/useDeleteScenicSpots'

export default {
  setup() {
    const scenicSpots = ref([])
    const conditions = reactive({
      division: null,
      keywords: ''
    })

    const loading = ref(false)

    const router = useRouter()
    const newDivision = () => {
      router.push({name: 'NewScenicSpots'})
    }

    const search = async (pagination) => {
      loading.value = true
      const {records, pagination: pagi} = await axios.get('/scenic_spots/', {
        params: {
          pagination,
          conditions
        }
      })
      scenicSpots.value = records
      return pagi
    }

    const {pagination, jumpTo} = usePagination(search)

    onMounted(() => {
      jumpTo(1)
    })

    const deleteScenic = useDeleteScenicSpots(() => search(pagination))

    return {
      deleteScenic,
      newDivision,
      division,
      conditions,
      pagination, jumpTo,
      scenicSpots,
      search
    }
  }
}
</script>
